import React, {useState, useEffect} from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import YouTubeViewer from '../YouTubeViewer';

export const HowItWorks = (props) => {

  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [activeVideo, setActiveVideo] = React.useState(null);

  const handleVideoStart = (videoId) => {
    if (activeVideo && activeVideo !== videoId) {
      setActiveVideo(null); // Stop the currently active video
    }
    setActiveVideo(videoId); // Set the new video as active
  };

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.handleAlertClose} open={props.open}>
      <IconButton onClick={props.handleAlertClose} className={classes.closeIcon}>
        <CancelIcon />
      </IconButton>
      <Box className={classes.root}>
          
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>How It Works</Typography>
        </Box>
        
        <Box className={classes.cardBody2}>
           <Box className={classes.cardContainer}>
             <YouTubeViewer
              onVideoStart={handleVideoStart}
              key={'HqzvtyRdmnI'}
              id={'HqzvtyRdmnI'}
              videoId={'HqzvtyRdmnI'}
              active={('HqzvtyRdmnI') === activeVideo}
            /> 
          </Box>
        </Box>
 
      </Box> 
    </Dialog>
  )
}
